import { DetailSectionTemplate } from "components/MainSectionTemplate/DetailSectionTemplate";
import React from "react";
import { useGroundTransportDetail } from "./useGroundTransportDetail";
import { groundTransportSections } from "./groundTransportSections";

interface Props {
  groundTransport: server.dto.GroundTransport
  linkedShows: server.dto.LinkedShow[]
  travellers: server.dto.ContactSmallV2[]

  onArtistChanged: (newArtist: server.dto.ArtistSmall) => void
  onDateChanged: (newDate: server.dto.AppointmentDateTime) => void
  onStatusChanged: () => void
}

export const GroundTransportDetailSection = (props: Props) => {
  const {
    state,
    hasDriver,
    hasMap,
    onValueChanged,
    onSuccessfulUpdate,
    getUpdateGroundTransportInstruction,
  } = useGroundTransportDetail(
    props.groundTransport,
    props.travellers,
    props.onArtistChanged,
    props.onDateChanged,
    props.onStatusChanged,
  );

  return <DetailSectionTemplate
    isInPageEditable={props.groundTransport.permissions.canModify}
    onValueChanged={onValueChanged}
    onSuccessfulUpdate={onSuccessfulUpdate}
    sections={groundTransportSections(state, props.linkedShows, getUpdateGroundTransportInstruction, hasDriver, hasMap)}
  />
}